import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-ivory pt-20 pb-8" data-id="element-104">
      <div className="container mx-auto px-6" data-id="element-105">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-106">
          {/* Column 1: Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/vNvN1XWtPWy9K7eBdDVvNB/Beshk-group-logo-icon.png" alt="The Beshk Group" className="w-20 h-20 object-contain mb-6" data-id="element-108" />
            <p className="text-[10px] uppercase tracking-widest text-terracotta mb-4" data-id="element-109">
              Selling Real Estate One Relationship at a Time
            </p>
            <p className="text-ivory/70 text-sm leading-relaxed" data-id="element-110">
              A family brokerage proudly serving the Phoenix Metro area since
              1992.
            </p>
          </div>

          {/* Column 2: Explore */}
          <div className="flex flex-col items-center md:items-start" data-id="element-111">
            <h4 className="font-serif text-xl mb-6" data-id="element-112">Explore</h4>
            <ul className="space-y-4 text-center md:text-left" data-id="element-113">
              <li data-id="element-114">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-115">
                  Home
                </a>
              </li>
              <li data-id="element-116">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-117">
                  Search Homes
                </a>
              </li>
              <li data-id="element-118">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-119">
                  Saved Searches
                </a>
              </li>
              <li data-id="element-120">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-121">
                  Home Valuation
                </a>
              </li>
              <li data-id="element-122">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-123">
                  Buy Smart
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-125">
                  Rentals
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: About */}
          <div className="flex flex-col items-center md:items-start" data-id="element-126">
            <h4 className="font-serif text-xl mb-6" data-id="element-127">About</h4>
            <ul className="space-y-4 text-center md:text-left" data-id="element-128">
              <li data-id="element-129">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-130">
                  About Us
                </a>
              </li>
              <li data-id="element-131">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-132">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-134">
                  Contact
                </a>
              </li>
              <li data-id="element-135">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-136">
                  Leave a Review
                </a>
              </li>
              <li data-id="element-137">
                <a href="#" className="text-ivory/70 hover:text-terracotta transition-colors text-sm" data-id="element-138">
                  Real Estate News
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Find Us */}
          <div className="flex flex-col items-center md:items-start" data-id="element-139">
            <h4 className="font-serif text-xl mb-6" data-id="element-140">Find Us</h4>
            <div className="space-y-4 text-center md:text-left text-sm text-ivory/70" data-id="element-141">
              <p data-id="element-142">
                1455 W. Redondo Drive
                <br data-id="element-143" />
                Gilbert, AZ 85233
              </p>
              <p data-id="element-144">
                Office: 602.309.8888
                <br data-id="element-145" />
                Cell: 480.215.2324
              </p>
              <div className="flex justify-center md:justify-start space-x-4 pt-4" data-id="element-146">
                <a href="#" className="hover:text-terracotta transition-colors" aria-label="Facebook" data-id="element-147">
                  <Facebook className="w-5 h-5" strokeWidth={1.5} data-id="element-148" />
                </a>
                <a href="#" className="hover:text-terracotta transition-colors" aria-label="Instagram" data-id="element-149">
                  <Instagram className="w-5 h-5" strokeWidth={1.5} data-id="element-150" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Legal Strip */}
        <div className="pt-8 border-t border-white/10 text-center text-xs text-ivory/40 flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4" data-id="element-151">
          <span data-id="element-152">&copy; 2026 The Beshk Group, Inc. All Rights Reserved.</span>
          <span className="hidden md:inline" data-id="element-153">|</span>
          <span data-id="element-154">Equal Housing Opportunity</span>
          <span className="hidden md:inline" data-id="element-155">|</span>
          <a href="#" className="hover:text-ivory transition-colors" data-id="element-156">
            Accessibility Statement
          </a>
          <span className="hidden md:inline" data-id="element-157">|</span>
          <a href="#" className="hover:text-ivory transition-colors" data-id="element-158">
            Sitemap
          </a>
        </div>
      </div>
    </footer>;
}